<template>
  <div class="sold-capacity">
    <img :src="url('/img/icons/full.svg')" alt="Plná kapacity" />
    <h3 v-html="$t('Sold capacity')"></h3>
  </div>
</template>
<script>
import { url } from "../../../../helpers";

export default {
  setup(props) {
    return {
      url,
    };
  },
};
</script>
